var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('settings-template',{attrs:{"layout":_vm.layout,"title":_vm.title,"show-device-picker":_vm.showDevicePicker}},[_c('background',{attrs:{"variable":_vm.variable}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }